import LogoImg from "../assets/img/tbc.svg";
import LogoImgAtb from "../assets/img/abt.svg";
import LogoImgBcf from "../assets/img/bcf.svg";
import LogoImgAbf from "../assets/img/abf.svg";

import LeftShape from "../assets/img/left-pink.svg";
import LeftShapeMobile from "../assets/img/left-mobile.svg";

import LeftShapeBcf from "../assets/img/left-black.svg";
import LeftShapeMobileBcf from "../assets/img/left-mobile-black.svg";

import LeftShapeAbt from "../assets/img/left-purple.svg";
import LeftShapeMobileAbt from "../assets/img/left-mobile-purple.svg";

import RightShape from "../assets/img/right-pink.svg";
import RightShapeMobile from "../assets/img/right-mobile.svg";

import RightShapeAbt from "../assets/img/right-purple.svg";
import RightShapeMobileAbt from "../assets/img/right-mobile-purple.svg";

import LeftShapeBcc from "../assets/img/left-green.svg";
import LeftShapeMobileBcc from "../assets/img/left-mobile-green.svg";
import RightShapeBcc from "../assets/img/right-green.svg";
import RightShapeMobileBcc from "../assets/img/right-mobile-green.svg";

import RightShapeBcf from "../assets/img/right-black.svg";
import RightShapeMobileBcf from "../assets/img/right-mobile-black.svg";

let projectTitleData = 'TravelBusinessClass'

if(process.env.REACT_APP_PROJECT === 'abt'){
  projectTitleData = 'AirBusinessTravel'
}
else if(process.env.REACT_APP_PROJECT === 'abf'){
  projectTitleData = 'AirBusinessFlights'
} else if (process.env.REACT_APP_PROJECT === 'bcf') {
  projectTitleData = 'BusinessClassFares'
}

export const projectTitle = projectTitleData

let menuSettingsData = {
  link:{
    home: 'https://travelbusinessclass.com/',
    bestDeal: 'https://travelbusinessclass.com/best-deal',
    blog: 'https://travelbusinessclass.com/blog',
    about: 'https://travelbusinessclass.com/about',
    covid19: 'https://travelbusinessclass.com/covid19',
    contact: 'https://travelbusinessclass.com/contact-us',
    privacy: 'https://travelbusinessclass.com/page/privacy_policy',
    terms: 'https://travelbusinessclass.com/page/terms_and_conditions'
  },
  LogoImg: LogoImg
}



if(process.env.REACT_APP_PROJECT === 'abt'){
  menuSettingsData = {
    link:{
      home: 'https://airbusinesstravel.com/',
      bestDeal: '',
      blog: '',
      about: '',
      covid19: '',
      contact: 'https://airbusinesstravel.com/#howToBook',
      privacy: 'https://airbusinesstravel.com/page/privacy_policy',
      terms: 'https://airbusinesstravel.com/page/terms_and_conditions'
    },
    LogoImg: LogoImgAtb
  }
}
else if(process.env.REACT_APP_PROJECT === 'abf'){
  menuSettingsData = {
    link:{
      home: '',
      bestDeal: '',
      blog: '',
      about: '',
      covid19: '',
      contact: '',
      privacy: '',
      terms: ''
    },
    LogoImg: LogoImgAbf
  }
}

else if(process.env.REACT_APP_PROJECT === 'bcf'){
  menuSettingsData = {
    link:{
      home: 'https://businessclassfares.com/',
      bestDeal: '',
      blog: '',
      about: 'https://businessclassfares.com/about',
      covid19: '',
      contact: 'https://businessclassfares.com/contact-us',
      privacy: 'https://businessclassfares.com/privacy',
      terms: 'https://businessclassfares.com/terms'
    },
    LogoImg: LogoImgBcf
  }
}

export const menuSettings = menuSettingsData;

let shapeData = {
  left: LeftShape,
  leftMobile: LeftShapeMobile,

  right: RightShape,
  rightMobile: RightShapeMobile,
}

if(process.env.REACT_APP_PROJECT === 'abt'){
  shapeData = {
    left: LeftShapeAbt,
    leftMobile: LeftShapeMobileAbt,

    right: RightShapeAbt,
    rightMobile: RightShapeMobileAbt,
  }
}
else if(process.env.REACT_APP_PROJECT === 'abf'){
  shapeData = {
    left: LeftShapeBcc,
    leftMobile: LeftShapeMobileBcc,

    right: RightShapeBcc,
    rightMobile: RightShapeMobileBcc,
  }
}

else if(process.env.REACT_APP_PROJECT === 'bcf'){
  shapeData = {
    left: LeftShapeBcf,
    leftMobile: LeftShapeMobileBcf,

    right: RightShapeBcf,
    rightMobile: RightShapeMobileBcf,
  }
}

export const shape = shapeData;
